import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase/firestore";
import { collection, getDocs, query, where } from "firebase/firestore";
import { useUser } from "../context/userContext";
import Header from "../Components/Header";

const Guest = () => {
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { premium: userIsPremium, id: userId, loading: userLoading } = useUser();

  // ✅ Telegram WebApp инициализация
  useEffect(() => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.ready();
      window.Telegram.WebApp.expand();
      
      // Показываем кнопку "Назад"
      window.Telegram.WebApp.BackButton.isVisible = true;
      window.Telegram.WebApp.BackButton.onClick(() => {
        console.log('Back button clicked in Guest');
        navigate(-1);
      });
    }

    // Cleanup
    return () => {
      if (window.Telegram?.WebApp) {
        window.Telegram.WebApp.BackButton.isVisible = false;
        window.Telegram.WebApp.BackButton.offClick();
      }
    };
  }, [navigate]);

  // ✅ Прокрутка в начало при загрузке страницы
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    
    // Альтернативный способ для большей надежности
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);

  useEffect(() => {
    const loadTrainings = async () => {
      try {
        const trainingsRef = collection(db, "trainings");
        const q = query(trainingsRef, where("category", "==", "Гости академии"));
        const snap = await getDocs(q);

        const items = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        items.sort((a, b) => (a.order || 0) - (b.order || 0));
        setTrainings(items);
      } catch (e) {
        console.error("Ошибка загрузки гостей академии:", e);
      } finally {
        setLoading(false);
      }
    };

    loadTrainings();
  }, []);

  const hasAccessToTraining = (training) => {
    if (!training.premium) return true;
    if (!userId) return false;
    return userIsPremium;
  };

  const handleTrainingClick = (training) => {
    const hasAccess = hasAccessToTraining(training);
    
    if (hasAccess) {
      navigate(`/training/${training.id}`);
    } else if (!userId) {
      alert("Авторизуйтесь через Telegram для доступа");
    } else {
      alert("Этот материал доступен только для Premium пользователей");
    }
  };

  if (loading || userLoading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center text-white relative">
        <div
          className="fixed inset-0"
          style={{
            backgroundImage: "url('/bghome.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            zIndex: -1
          }}
        />
        <div className="relative z-10">Загрузка...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen w-full text-white relative">
      {/* 🖼️ ФОН-КАРТИНКА БЕЗ ЗАТЕМНЕНИЯ */}
      <div
        className="fixed inset-0"
        style={{
          backgroundImage: "url('/bghome.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          zIndex: -1
        }}
      />

      {/* ✨ ДЕКОР СНИЗУ */}
      <div className="fixed bottom-0 left-0 right-0 h-[150px] bg-[radial-gradient(circle_at_center,rgba(120,0,255,0.15),transparent_70%)] z-0" />

      {/* КОНТЕНТ */}
      <div className="relative z-10 min-h-screen flex flex-col">
        {/* ✅ ДОБАВЛЕН HEADER */}
        <div className="pt-0">
          <Header />
        </div>
        
        {/* ОСНОВНОЙ КОНТЕНТ */}
        <div className="flex-1 px-4 pt-6 pb-24 overflow-y-auto">
          <h1 className="text-white text-[18px] font-semibold mb-6">
            ГОСТИ АКАДЕМИИ
          </h1>

          {/* Список тренингов */}
          <div className="flex flex-col gap-4">
            {trainings.length === 0 ? (
              <div className="text-center text-white/60 py-8">
                Пока нет контента
              </div>
            ) : (
              trainings.map((training) => {
                const hasAccess = hasAccessToTraining(training);
                const isLocked = training.premium && !hasAccess;
                
                return (
                  <div
                    key={training.id}
                    className={`w-full rounded-[20px] border p-4 flex items-center gap-4 ${isLocked ? 'opacity-70' : ''}`}
                    style={{
                      background: "#241352",
                      borderColor: isLocked ? "#EF4444" : "rgba(255,255,255,0.2)"
                    }}
                  >
                    {/* Картинка */}
                    <div className="w-[72px] h-[72px] rounded-[12px] overflow-hidden shrink-0">
                      <img
                        src={training.image || "https://images.unsplash.com/photo-1545235617-9465d2a55698?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80"}
                        alt={training.title}
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Контент */}
                    <div className="flex-1 flex flex-col justify-between min-h-[72px]">
                      <div>
                        <div className="flex items-center gap-2">
                          <div
                            className="text-[16px] leading-tight font-medium break-words whitespace-normal"
                            style={{ color: isLocked ? "#94A3B8" : "#C8AFE8" }}
                          >
                            {training.title}
                          </div>
                          {training.premium && (
                            <span className={`px-2 py-0.5 rounded-full text-xs ${hasAccess ? 'bg-yellow-500/20 text-yellow-300' : 'bg-red-500/20 text-red-300'}`}>
                              Premium
                            </span>
                          )}
                        </div>
                        
                        <div className="flex items-center gap-2 mt-1">
                          <div
                            className="text-[14px] font-medium"
                            style={{ color: isLocked ? "#EF4444" : "#34D3FF" }}
                          >
                            {isLocked ? "Заблокировано" : "Доступно"}
                          </div>
                        </div>
                        
                      </div>

                      {/* Кнопка */}
                      <div className="mt-3">
                        <button
                          className={`px-6 py-2 rounded-full text-white text-[15px] font-medium active:scale-95 transition ${isLocked ? 'cursor-not-allowed' : 'hover:opacity-90'}`}
                          style={{
                            background: isLocked ? "#6B7280" : "#6B3FD8",
                          }}
                          onClick={() => handleTrainingClick(training)}
                          disabled={isLocked}
                        >
                          {isLocked ? "Заблокировано" : "Смотреть"}
                        </button>
                        
                        {isLocked && training.premium && !userIsPremium && userId && (
                          <p className="text-xs text-yellow-400 mt-2 text-center">
                            Требуется Premium подписка
                          </p>
                        )}
                        
                        {isLocked && !userId && (
                          <p className="text-xs text-pink-400 mt-2 text-center">
                            Требуется авторизация
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Guest;